/**
 * @fileoverview PUT handler for the "/engagement/landing_pages/:app_group_id/:landing_page_bson_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdLandingPageIdCacheKeys } from "./constants";
import type {
  PutEngagementLandingPagesAppGroupIdLandingPageIdProps,
  EngagementLandingPagesAppGroupIdLandingPagePutIdResult,
} from "./types";

export const putEngagementLandingPagesAppGroupIdLandingPageId = reactQueryMutationAdapter(
  engagementLandingPagesAppGroupIdLandingPageIdCacheKeys,
  (
    props: PutEngagementLandingPagesAppGroupIdLandingPageIdProps
  ): Promise<EngagementLandingPagesAppGroupIdLandingPagePutIdResult> => {
    const { app_group_id: appGroupId, landing_page_bson_id: landingPageBsonId } = props;
    return fetch(`/engagement/landing_pages/${appGroupId}/${landingPageBsonId}`, "PUT", props);
  }
);
